import Spinner from 'src/javascripts/components/utilities/Spinner';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, genericDisplayTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');
import Questions from 'src/javascripts/components/surveys/Questions'

export default class SurveysQuestionsEdit {

  constructor() {}

  render() {
    let accountUrl = $('body').attr('data-account-url');

  	Questions();

    // Display content results
    const contentDisplayAllTemplate = (title, content, id) => '<div class=\'card mb-2 clickable bg-gray100 content-search-option\' data-title=\'' + title + '\' data-content-id=\'' + id + '\'>' +
      '<div class=\'card-body\'><div class="mb-1 text-gray600" style=\'font-size: 13px; font-family: Inter;\'>' + title + '</div>' +
      '<div class=\'text-gray500\' style=\'font-size: 11px; font-family: Inter;\'>' + content + '</div>' +
      '</div></div>';

    // Content search
    let contentsBloodhound = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: '/' + accountUrl + '/surveys/contents?query=%QUERY',
        wildcard: "%QUERY",
        cache: false
      }});
    contentsBloodhound.initialize();
    $('#contents_search').typeahead({
      hint: true,
      highlight: true,
      minLength: 0,
      classNames: {
        menu: 'd-none' // add class name to menu so default dropdown does not show
      }
    }, {
      name: 'contents',
      display: 'name',
      limit: 351,
      source: contentsBloodhound.ttAdapter(),
      menu: '#contentsSearchResults'
    });

    $('#contents_search').on('typeahead:render', function (e, datum) {
      $('#contentsSearchResults').empty();
      $('#contentsSearchResults').closest('.form-group').removeClass('d-none');
      Spinner($('#contentsSearchResults'));
      if ((typeof datum !== 'undefined') && (datum.length > 0)) {

        //empty suggestion div to display results
        for (var c = 0; c < datum.length; c++) {

          // Set template to render
          let template;
          template = contentDisplayAllTemplate(datum[c].name, datum[c].content, datum[c].record_id);

          // Append to companies search list
          $('#contentsSearchResults').append(template);

        }

        // Remove spinner
        $('#contentsSearchResults').find('.spinner-container').remove();

      } else {

        // Append to companies search list
        $('#contentsSearchResults').find('.spinner-container').remove();
        $('#contentsSearchResults').empty().append("No content found")
        
      }

      // Update selected on click 
      $('.content-search-option').click(function(ev) {
        let qid = $(this).attr('data-content-id');
        let qText = $(this).attr('data-title');
        $('#existing_content_id').val(qid);
        $('#contents_search').val(qText);
        $('#contentsSearchResults').closest('.form-group').addClass('d-none');
      });

    });
    
    // On clear typeahead
    $('.clear-contents-typeahead').click(function() {
      $('#existing_content_id').val("");
      $('#contents_search').typeahead("val", "");
      $('#contents_search').focus();
      $('#contentsSearchResults').closest('.form-group').removeClass('d-none');
    })

    // Focus content
    if ($('#contents_search').length !== 0) {
      $('#contents_search').focus();
    }


  }

}

